<template>

  <div class="icp-footer">
    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502015451" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
      <img src="" style="float:left;"/><p style=" color:#939393;">
      沪公网安备 31011502015451号</p ></a> &nbsp; 沪ICP备05025522号 Copyright © 2016-2023美蓝飘尔（上海）过滤设备有限公司
  </div>
</template>

<script>
  export default {
      name:'IcpFooter'
  }
</script>

<style>
  .icp-footer{
    width: 100%;
    position: fixed;
    bottom: 5px;
    z-index: -1;
    text-align: center;
    font-size: 12px;
    line-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue